<app-entity-transaction-modal
  modalTitle="TRANSACTIONS"
  ariaLabelledBy="entity-account-details-modal-title"
  [dataLoading]="dataLoading()"
  [dataAvailable]="dataAvailable()"
  [dataEmpty]="dataEmpty()"
  [columns]="columns()"
  [currentPage]="currentPage()"
  [sortField]="sortField()"
  [sortOrder]="sortOrder()"
  (sortChanged)="sort($event)"
  (searchChanged)="search($event)"
  (pageChanged)="page($event)">
  <ng-container entityInfo>
    <h2>Name: {{entityAccount().name}}</h2>
    <h2>Number:
      @if (entityAccount().number) {
        <span>{{entityAccount().number}}</span>
      }
      @if (!entityAccount().number) {
        <span class="fallback-text">(Empty)</span>
      }
    </h2>
    <h2>Balance: {{entityAccount().balance.displayValue}}</h2>
  </ng-container>
</app-entity-transaction-modal>
